<template>
  <div class="my-data">
    <div v-if="users.length > 0">
      <van-swipe ref="swipe" :autoplay="0" :show-indicators="true" @change="changeUser">
        <van-swipe-item v-for="(user, index) in users" :key="index">
          <div style="background-color: #ffffff; border-radius: 8px">
            <div class="user-info">
              <img :src="imageView(user.avatar)" style="width: 88px; height: 130px;">
              <div class="info">
                <div style="font-size: 12px; font-weight: 500">{{ user.trueName }}</div>
                <div style="font-size: 12px">{{ getAge(user.bmBirthday) }}</div>
              </div>
              <div class="more" @click="goMore" v-if="showMore">更多</div>
            </div>
            <div class="data">
              <div class="data-item">
                <div class="number">{{ user.gameCount }}</div>
                <div class="label">参赛数</div>
              </div>
              <div class="data-item">
                <div class="number">{{ user.allR }}</div>
                <div class="label">总得分</div>
              </div>
              <div class="data-item">
                <div class="number">{{ user.allH }}</div>
                <div class="label">总安打</div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div class="match" v-for="(match, index) in list" :key="'match' + index" @click="goMatchData(match)">
        <div class="match-name">
          <div class="icon"></div>
          <span>{{ match.chineseName }}</span>
        </div>
        <div class="group">组别：<span style="font-weight: 500; font-size: 15px">{{ match.group }}</span></div>
        <div class="data">
          <div class="data-item">
            <div class="number">{{ match.allP }}</div>
            <div class="label">上场局数</div>
          </div>
          <div class="data-item">
            <div class="number">{{ match.allR }}</div>
            <div class="label">得分</div>
          </div>
          <div class="data-item">
            <div class="number">{{ match.allH }}</div>
            <div class="label">安打</div>
          </div>
          <div class="data-item">
            <div class="number">{{ match.allNH }}</div>
            <div class="label">非安打上垒</div>
          </div>
        </div>
      </div>
    </div>
    <van-empty v-else description="暂无数据" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage, Swipe, SwipeItem, Empty } from 'vant'
import { QNImageUtil } from "@/utils";
import { getBMMLBBaseballStatsByUser } from "@/api/match";
Vue.use(VanImage).use(Swipe).use(SwipeItem).use(Empty)

export default {
  name: "index",
  data() {
    return {
      accountId: '',
      users: [],
      list: [],
      showMore: false,
      IDCardNo: '',
      i: -1
    }
  },
  mounted() {
    this.accountId = this.$route.query.accountId
    if (this.$route.query.IDCardNo) {
      this.IDCardNo = this.$route.query.IDCardNo
    }
    this.getBMMLBBaseballStatsByUser()
  },
  methods: {
    goMore() {
      this.$router.push(`/match/user-list/${this.accountId}`)
    },
    getBMMLBBaseballStatsByUser() {
      const params = {
        accountId: this.accountId,
        needMatchInfo: 0
      }
      getBMMLBBaseballStatsByUser(params).then(res => {
        if (res) {
          const { data } = res
          const list = data.list || []
          if (this.IDCardNo) {
            const index = list.findIndex(l => l.IDCardNo === this.IDCardNo)
            if (index > -1) {
              const temp = list[0]
              list[0] = list[index]
              list[index] = temp
            }
          }
          if (list.length > 5) {
            this.users = list.slice(0, 5)
            this.showMore = true
          } else {
            this.users = list
          }
          if (this.users.length > 0) {
            this.changeUser(0)
          }
        }
      })
    },
    goMatchData(match) {
      this.$router.push(`/match/match-data/${match.matchId}?IDCardNo=${this.users[this.i].IDCardNo}`)
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getAge(birthday) {
      if (!birthday) return ''
      const now = new Date()
      const b = new Date(birthday)
      let age = now.getFullYear() - b.getFullYear()
      if (now.getMonth() < b.getMonth()) {
        age--
      } else if (now.getMonth() === b.getMonth() && now.getDate() < b.getDate) {
        age--
      }
      return `${age}岁`
    },
    changeUser(index) {
      this.i = index
      const params = {
        accountId: this.accountId,
        IDCardNo: this.users[index].IDCardNo
      }
      getBMMLBBaseballStatsByUser(params).then(res => {
        if (res) {
          const { data } = res
          const list = data.list || []
          if (list.length > 0) {
            this.list = list[0].matchList || []
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my-data {
  background-color: #F6F6F8;
  min-height: 100vh;
  padding: 20px 12px;
  .user-info {
    position: relative;
    display: flex;
    padding: 12px;
    .info {
      margin-left: 8px;
    }
    .more {
      position: absolute;
      top: 12px;
      right: 20px;
      font-size: 12px;
      color: #409EFF;
      text-decoration: #409EFF underline;
    }
  }
  .data {
    display: flex;
    justify-content: space-around;
    margin-bottom: 12px;
    .data-item {
      display: flex;
      flex-flow: column;
      align-items: center;
      padding-bottom: 8px;
      width: 80px;
      .number {
        font-size: 18px;
        font-weight: 500;
        padding: 4px 0;
      }
      .label {
        font-size: 12px;
        color: #8C8C8C;
      }
    }
  }
  .match {
    background-color: #ffffff;
    padding: 0 12px;
    border-radius: 8px;
    .match-name {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333333;
      padding: 12px 0;
      border-bottom: 0.5px #EEEEEE solid;
      .icon {
        width: 2px;
        height: 12px;
        background-color: red;
        margin-right: 6px;
      }
    }
    .group {
      font-size: 12px;
      display: flex;
      align-items: center;
      padding: 8px 0 5px 0;
      color: #8C8C8C;
    }
  }
}
</style>
